import * as z from 'zod';

// Zod v4: set a global error map using z.config({ customError })
export const zonConfig = z.config({
  customError: (iss) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (iss.code === 'invalid_type' && (iss as any).expected === 'object') {
      return 'Invalid {FIELD_NAME} provided';
    }
    // defer to default locale error message
    return undefined;
  },
});
